export var NotificationType;
(function (NotificationType) {
    NotificationType["DIALOG"] = "DIALOG";
    NotificationType["SUCCESS"] = "SUCCESS";
    NotificationType["ERROR"] = "ERROR";
    NotificationType["WARNING"] = "WARNING";
})(NotificationType || (NotificationType = {}));
export var NotificationActions;
(function (NotificationActions) {
    NotificationActions["SHOW_NOTIFICATION"] = "NOTIFICATION/SHOW_NOTIFICATION";
    NotificationActions["HIDE_NOTIFICATION"] = "NOTIFICATION/HIDE_NOTIFICATION";
    NotificationActions["CLEAR_NOTIFICATION"] = "NOTIFICATION/CLEAR_NOTIFICATION";
})(NotificationActions || (NotificationActions = {}));
